/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
import router from '@/router';
import { familiariService } from '@/services';
import get from 'lodash/get';
import find from 'lodash/find';
import i18n from '../../i18n';

export const state = {
  all: {},
  familiari: {},
  familiareCf: {},
  message: '',
};

export const getters = {
  familiari: state => get(state.familiari, ['items']) || [],
  familiare: (state, getters) => id =>
    find(getters.familiari, ['id', id]) || {},
  message: state => state.message,
  individual: state => get(state.familiareCf, ['items', 'individual']) || {},
};

export const actions = {
  init({ state, dispatch }) {
    state.all = {};
    state.familiari = [];
    state.familiareCf = {};
    state.message = '';
  },
  getfamiliari({ commit, dispatch }) {
    familiariService
      .getfamiliari()
      .then((response) => {
        commit('getAllSuccess', response);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getFamiliariMinore({ commit, dispatch }, { id }) {
    familiariService
      .getFamiliariMinore(id)
      .then((response) => {
        commit('getFamiliariminoreSuccess', response.data);
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
  getFamiliariByCf({ commit, dispatch }, { id, cf }) {
    commit('getAllRequest');
    return familiariService
      .getFamiliareCf(id, cf)
      .then((response) => {
        if (response.status === 204) {
          router.replace({ name: 'GenitoriNew', params: { id, cf } });
        } else {
          commit('getFamiliariCf', response.data);
          router.replace({ name: 'GenitoriAssociate', params: { id } });
        }
      })
      .catch((error) => {
        if (error.status === 422) {
          dispatch(
            'notificationService',
            { type: 'error', text: i18n.t('all.notValidTaxCode') },
            { root: true },
          );
        } else if (error.status === 409) {
          dispatch(
            'notificationService',
            {
              type: 'error',
              text: i18n.t('all.userNotTutor'),
            },
            { root: true },
          );
        } else if (error.status === 304) {
          dispatch(
            'notificationService',
            {
              type: 'error',
              text: i18n.t('all.userAlreadyAssociated'),
            },
            { root: true },
          );
        } else {
          dispatch(
            'notificationService',
            { type: 'error', text: i18n.t('all.generalError') },
            { root: true },
          );
        }
      });
  },
  associateFamiliari({ commit, dispatch }, { id, associate }) {
    commit('getAllRequest');
    familiariService.associateFamiliari(id, associate).then(
      (response) => {
        if (response.status === 204) {
          router.replace({ name: 'Genitori', params: { id } });
        } else {
          dispatch(
            'notificationService',
            { type: 'error', text: i18n.t('all.associate_error') },
            { root: true },
          );
        }
      },
      (error) => {
        console.log(error);
      },
    );
  },
  associateFamiliariToMinor(
    { commit, dispatch },
    { id, individual, associate },
  ) {
    commit('getAllRequest');
    familiariService
      .associateFamiliariToMinor(id, individual, associate)
      .then((response) => {
        if (response.status === 204) {
          router.replace({ name: 'Genitori', params: { id } });
        } else {
          dispatch(
            'notificationService',
            { type: 'error', text: i18n.t('all.associate_error') },
            { root: true },
          );
        }
      })
      .catch((error) => {
        dispatch(
          'notificationService',
          { type: 'error', text: error },
          { root: true },
        );
      });
  },
};

export const mutations = {
  getAllRequest(state) {
    state.message = '';
  },
  setErrorMessage(state, message) {
    state.message = message;
  },
  getFamiliariCf(state, familiare) {
    state.familiareCf = {
      items: familiare,
    };
  },
  getAllSuccess(state, familiari) {
    state.familiari = {
      items: familiari,
    };
  },
  getFamiliariminoreSuccess(state, familiari) {
    state.familiari = {
      items: familiari,
    };
  },
  getAllFailure(state, error) {
    state.all = {
      error,
    };
  },
  addAllSuccess(state, familiari) {
    state.all = {
      items: familiari,
    };
  },
};
